import React from "react";

export const FooterComponent = () => {
  return (
    <>
      <tmo-digital-footer brand="metro" client-id='metro'></tmo-digital-footer>
    </>
  );
};
